import React from 'react';
import { IPlannedActivitiesTab } from './interfaces';
import { useTranslation } from 'react-i18next';
import { Tab } from '../../../../../components/tabs';
import TodayIcon from '@mui/icons-material/Today';

export const PlannedActivitiesTab: React.FC<IPlannedActivitiesTab> = ({
  label,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tab
      label={label || t('clients:details.plannedActivitiesTab.label')}
      icon={<TodayIcon />}
      {...other}
    />
  );
};
